import { cx } from '@linaria/core';
import { resets } from '@ui/css';
import { label, wrapper, toggledModifier } from './chip.style.js';
export { selectors as chipSelectors } from './chip.style.js';
import { jsx } from 'react/jsx-runtime';

function Chip(props) {
  return /*#__PURE__*/jsx("button", {
    onClick: props.onClick,
    className: cx(resets.rootCls, wrapper, props.className, props.toggled && toggledModifier),
    "data-size": props.size,
    disabled: props.disabled,
    children: /*#__PURE__*/jsx("span", {
      className: label,
      children: props.children
    })
  });
}

export { Chip };
//# sourceMappingURL=chip.js.map
